import React from "react";
import styled from "styled-components";
import { PropTypes } from 'prop-types';
import OpenAI from '../../services/OpenAI';
import Scrollable from "../Scrollable";
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';
import LoadingIndicator from "../LoadingIndicator";

const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  h1 {
    font-weight: 500;
  }
  > p {
    margin: 0.5rem;
  }
  img {
    width: 60px;
  }
  ol {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  input[type="text"] {
    padding: 10px 3rem 10px 1rem;
  }
  button {
    background: #1ebd53;
    padding: 0.75rem 1.5rem;
    border-radius: 0.5rem;
    color: white;
    text-align: center;
    font-weight: 500;
  }
`;
const Suggestions = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  padding: 0 2rem 2rem;
  > div {
    border: 1px dashed black;
    padding: 0 1rem;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    h3 {
      font-weight: 500;
      text-transform: capitalize;
    }
    > div {
      flex: 1;
    }
    button {
      margin: 1rem 0;
    }
  }
`;

class GoInteractive extends LogictryComponent {
  static propTypes = {
    onComplete: PropTypes.func,
    action: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    onPromptSelect: PropTypes.func,
    color: PropTypes.string,
    company: PropTypes.string,
  }
  state = {
    busy: false,
    letters: 0,
    response: '',
  }
  componentDidMount() {
    OpenAI.onStateUpdate(this.openAIUpdate);
    const { action, title, description, color, company } = this.props;
    if (this.state.busy) return;
    this.openAIText = '';
    if (action === 'analyzetext') {
      this.setState({ busy: true, letters: 0, response: '' });
      this.startInterval();
      return OpenAI.getSuggestions(description);
    }
    if (action === 'directory') {
      this.state.generating = description;
      this.state.letters = 0;
      this.state.busy = true;
      this.state.response = '';
      this.startInterval();
      OpenAI.createDirectoryPipeline({
        title,
        description,
        color,
        company,
      });
      return;
    }
    return this.generateContent(action, title, description, color, company);
  }
  componentWillUnmount() {
    OpenAI.offStateUpdate(this.openAIUpdate);
    clearInterval(this.textUpdateInterval);
  }
  startInterval = () => {
    this.textUpdateInterval = setInterval(this.textUpdate, 4);
  }
  openAIUpdate = () => {
    if (!OpenAI.openAIState) return;
    const { generating } = this.state;
    const { response, complete } = OpenAI.openAIState;
    if (generating) {
      this.openAIText = response || '';
      this.setState({ busy: !complete });
      this.state.busy = !complete;
      this.forceUpdate();
    } else if (OpenAI.suggestions) {
      this.openAIText = OpenAI.suggestions.join('\n\n________________________\n\n');
      this.state.busy = !complete;
      this.forceUpdate();
    }
    if (complete) {
      clearInterval(this.textUpdateInterval);
      this.textUpdateInterval = null;
      this.props.onComplete(response);
    }
  }
  textUpdate = () => {
    let { letters } = this.state;
    const totalText = this.openAIText || '';
    if (totalText.length > letters) letters += 1;
    this.setState({ response: totalText.slice(0, letters), letters });
  }
  generateContent = async (type, title, description, color, company) => {
    this.state.generating = description;
    this.state.letters = 0;
    this.state.busy = true;
    this.state.response = '';
    this.startInterval();
    OpenAI.createContent({ type, title, description, color, company });
  }
  render() {
    const { busy, response } = this.state;
    const { suggestions } = OpenAI;
    return (
      <Scrollable
        key={"Go Interactive"}
        style={{ position: 'absolute', inset: 0 }}
        rememberScrollPosition={`gointeractive`}
        vertical
      >
        <Wrapper>
          {busy && <div style={{ width: '100%', padding: '0 2.5rem 2rem' }}>
            <div style={{ marginBottom: '1rem' }}>
              <LoadingIndicator />
            </div>
            {response && <div
              style={{ whiteSpace: 'pre-wrap' }}
            >{response}</div>}
          </div> || suggestions && <Suggestions>
            {suggestions.map((t) => (
              <div key={t}>
                <div>
                  <p style={{ whiteSpace: 'pre-wrap' }}>{t}</p>
                </div>
                <button onClick={() => this.props.onPromptSelect(t)}>Use Prompt</button>
              </div>
            ))}
          </Suggestions>}
        </Wrapper>
      </Scrollable>
    )
  }
};
export default GoInteractive;
